/* eslint-disable no-underscore-dangle */
import { BiddingData } from 'store/modules/bidding_store/types';
import { FollowupData } from 'store/modules/followup_store/types';
import { BulletinBiddingsTypes, BulletinFollowupTypes } from 'store/modules/bulletins_store/types';
import { ContractItemTypes } from 'store/modules/contracts_store/types';
import { ObjectImminenceTypes } from 'store/modules/get_dados_imminence_store/types';
import _ from 'underscore';
import {
  ManagedData,
  NotificationProgressData,
  TaskData,
} from 'store/modules/management_store/types';

export interface toggleSelectedTypes {
  id: number;
  updateAll?: boolean;
  wholePageSelected: boolean;
  sourceList:
    | Array<BulletinBiddingsTypes>
    | Array<BiddingData>
    | Array<ObjectImminenceTypes>
    | Array<ContractItemTypes>
    | Array<BulletinFollowupTypes>
    | Array<FollowupData>
    | Array<ManagedData>
    | Array<TaskData>
    | Array<NotificationProgressData>;
  selectedList: Array<number>;
  setSelectedList: (value: React.SetStateAction<number[]>) => void;
}

export const toggleSelected = (params: toggleSelectedTypes) => {
  const {
    id,
    updateAll = false,
    wholePageSelected,
    sourceList,
    selectedList,
    setSelectedList,
  } = params;

  if (updateAll) {
    if (wholePageSelected) {
      const selectedBiddingList = sourceList.map((item) => {
        if ('_source' in item) return item?._source?.id;
        if ('followup_id' in item) return item?.followup_id;
        if ('bulletin_id' in item) return Number(item.bidding_id);
        if ('total_managed_opened_tasks' in item) return item?.id;
        if ('notification_reason_id' in item) return item?.id;
        if ('status_task_id' in item) return item?.id;

        return Number(item.bidding_id);
      });
      setSelectedList(
        selectedList.filter((selectedBidding) => !selectedBiddingList.includes(selectedBidding)),
      );
    }
    if (!wholePageSelected) {
      setSelectedList(
        _.uniq([
          ...selectedList,
          ...(sourceList.map((item) => {
            if ('_source' in item) return item?._source?.id;
            if ('followup_id' in item) return item?.followup_id;
            if ('bulletin_id' in item) return Number(item.bidding_id);
            if ('total_managed_opened_tasks' in item) return item?.id;
            if ('notification_reason_id' in item) return item?.id;
            if ('status_task_id' in item) return item?.id;

            return Number(item.bidding_id);
          }) || []),
        ]),
      );
    }
  }
  if (!updateAll) {
    if (selectedList.includes(id))
      setSelectedList(selectedList.filter((selectedBidding) => selectedBidding !== id));
    if (!selectedList.includes(id)) setSelectedList([...selectedList, id]);
  }
};
